var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('EditorComponent',{attrs:{"html":_vm.data['text'],"for-reference":""},on:{"done":function (c) { return _vm.update(c); }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }